<template>
  <main class="ead-agenda">
    <rh-cabecalho pagina="agenda" subtitulo="AGENDA" titulo="" descricao=""
      :unidade-id="unidadeId" :empresas="empresas" mostrar-pessoas
      :mostrar-configuracao="isInRole('rh-diretoria')" @empresa-selecionada="selecionarEmpresa" />
    <b-message v-if="erro" type="is-danger" aria-close-label="Fechar" @close="erro = ''">{{ erro }}</b-message>
    <section class="box">
      <div class="ead-toolbar">
        <b-field label="Responsável da agenda">
          <b-select v-model="responsavelId" expanded @input="recarregar">
            <option :value="null">Todos</option>
            <option v-for="p in funcionarios" :key="p.id" :value="p.id">{{ p.nome }}</option>
          </b-select>
        </b-field>
        <b-button type="is-primary" icon-left="plus" :disabled="!unidadeId || !funcionarios.length" @click="novo()">Adicionar</b-button>
      </div>
      <div class="ead-tipos" aria-label="Tipos de agendamento">
        <b-button v-for="item in tiposFiltro" :key="item.valor" size="is-small"
          :type="tipoFiltro === item.valor ? 'is-primary' : 'is-light'" @click="tipoFiltro = item.valor; recarregar()">
          <span v-if="item.cor" class="ead-dot" :style="{ backgroundColor: item.cor }"></span>{{ item.nome }}
        </b-button>
      </div>
      <b-loading :active="loading" :is-full-page="false"></b-loading>
      <FullCalendar ref="calendario" :options="opcoesCalendario" />      
    </section>
    <b-modal :active.sync="modal" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <ValidationObserver v-slot="{ handleSubmit }" slim>
        <form class="modal-card" @submit.prevent="handleSubmit(salvar)">
          <header class="modal-card-head"><p class="modal-card-title">{{ formulario.id ? 'Editar evento' : 'Adicionar evento' }}</p></header>
          <section class="modal-card-body">
            <b-message v-if="formulario.origemId" type="is-info" :closable="false">Este evento veio do Desenvolvimento. Uma alteração posterior no registro de origem atualizará os dados da agenda.</b-message>
            <ValidationProvider v-slot="{ errors }" name="Funcionário" rules="required">
              <b-field label="Funcionário" :type="errors.length ? 'is-danger' : ''" :message="errors[0]">
                <b-select v-model="formulario.funcionarioId" expanded><option :value="null">Selecione</option>
                  <option v-for="p in funcionarios" :key="p.id" :value="p.id">{{ p.nome }}</option></b-select>
              </b-field>
            </ValidationProvider>
            <ValidationProvider v-slot="{ errors }" name="Tipo de agenda" rules="required">
              <b-field label="Tipo de agenda" :type="errors.length ? 'is-danger' : ''" :message="errors[0]">
                <b-select v-model="formulario.tipo" expanded><option value="">Selecione</option>
                  <option v-for="t in tiposFiltro.slice(1)" :key="t.valor" :value="t.valor">{{ t.nome }}</option></b-select>
              </b-field>
            </ValidationProvider>
            <ValidationProvider v-slot="{ errors }" name="Responsável" rules="required">
              <b-field label="Responsável" :type="errors.length ? 'is-danger' : ''" :message="errors[0]">
                <b-select v-model="formulario.responsavelId" expanded><option :value="null">Selecione</option>
                  <option v-for="p in funcionarios" :key="p.id" :value="p.id">{{ p.nome }}</option></b-select>
              </b-field>
            </ValidationProvider>
            <ValidationProvider v-slot="{ errors }" name="Data e hora de início" rules="required">
              <b-field label="Data e hora de início" :type="errors.length ? 'is-danger' : ''" :message="errors[0]">
                <b-input v-model="formulario.inicio" type="datetime-local" /></b-field>
            </ValidationProvider>
            <ValidationProvider v-slot="{ errors }" name="Data e hora de fim" rules="required">
              <b-field label="Data e hora de fim" :type="errors.length ? 'is-danger' : ''" :message="errors[0]">
                <b-input v-model="formulario.fim" type="datetime-local" /></b-field>
            </ValidationProvider>
            <b-field label="Observações"><b-input v-model="formulario.observacoes" type="textarea" maxlength="10000" /></b-field>
          </section>
          <footer class="modal-card-foot"><b-button @click="modal = false">Fechar</b-button>
            <b-button type="is-primary" native-type="submit" :loading="salvando">Salvar</b-button></footer>
        </form>
      </ValidationObserver>
    </b-modal>
    <b-modal :active.sync="modalEvento" has-modal-card trap-focus aria-role="dialog" aria-modal>
      <div v-if="selecionado" class="modal-card">
        <header class="modal-card-head"><p class="modal-card-title">{{ selecionado.titulo }}</p></header>
        <section class="modal-card-body">
          <p><strong>Responsável:</strong> {{ selecionado.responsavel }}</p>
          <p><strong>Período:</strong> {{ dataHora(selecionado.inicio) }} até {{ dataHora(selecionado.fim) }}</p>
          <p><strong>Status:</strong> {{ selecionado.status }}</p>
          <p v-if="selecionado.observacoes"><strong>Observações:</strong> {{ selecionado.observacoes }}</p>
          <b-message v-if="!selecionado.id" type="is-info" :closable="false">Registro anterior à Agenda. Para alterá-lo, use a tela de Desenvolvimento.</b-message>
          <div class="buttons mt-4" aria-label="Menu do evento">
            <b-button v-if="selecionado.id" icon-left="pencil" @click="editarSelecionado">Editar</b-button>
            <b-button v-if="selecionado.id && selecionado.status !== 'confirmado'" type="is-success" icon-left="check" :loading="alterandoStatus" @click="confirmarEvento">Confirmar</b-button>
            <b-button v-if="selecionado.id && selecionado.status !== 'cancelado'" type="is-danger" icon-left="close" :disabled="alterandoStatus" @click="confirmarCancelamento">Cancelar</b-button>
            <b-button v-if="selecionado.id" icon-left="history" @click="abrirHistorico">Histórico</b-button>
          </div>
          <div v-if="mostrarHistorico"><h3 class="subtitle is-6">Histórico</h3>
            <p v-if="!historico.length">Nenhuma alteração registrada.</p>
            <p v-for="(h, i) in historico" :key="i">{{ dataHora(h.data) }} — {{ h.acao }} — {{ h.autor }}</p>
          </div>
        </section>
        <footer class="modal-card-foot"><b-button @click="modalEvento = false">Fechar</b-button></footer>
      </div>
    </b-modal>
  </main>
</template>

<script>
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import listPlugin from '@fullcalendar/list'
import interactionPlugin from '@fullcalendar/interaction'
import ptBrLocale from '@fullcalendar/core/locales/pt-br'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapGetters } from 'vuex'
import http from '@/http'
import RhCabecalho from '@/components/rh_cabecalho.vue'

const cores = ['#5B8DEF', '#E47461', '#7BBD79', '#A879D6', '#E3AD40']
const nomes = [
  { valor: 'avaliacao', nome: 'AVALIAÇÕES' }, { valor: 'pdi', nome: 'PDI' },
  { valor: '1:1', nome: '1:1' }, { valor: 'meta', nome: 'Metas' }, { valor: 'outros', nome: 'Outros' },
]
const pad = (n) => String(n).padStart(2, '0')
function local(v) {
  const d = new Date(v)
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
}

export default {
  name: 'RhAgenda',
  components: { FullCalendar, RhCabecalho, ValidationObserver, ValidationProvider },
  data() {
    const coresSorteadas = cores.slice().sort(() => Math.random() - 0.5)
    return {
      empresas: [], unidadeId: null, funcionarios: [], eventos: [], responsavelId: null,
      tipoFiltro: 'todos', tiposFiltro: [{ valor: 'todos', nome: 'TODOS', cor: null }, ...nomes.map((x, i) => ({ ...x, cor: coresSorteadas[i] }))],
      loading: false, salvando: false, alterandoStatus: false, erro: '', modal: false, modalEvento: false,
      pedidoAtual: 0,
      formulario: {}, selecionado: null, historico: [], mostrarHistorico: false,
      periodo: { inicio: null, fim: null },
      opcoesCalendario: {
        plugins: [dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin], locale: ptBrLocale,
        initialView: 'dayGridMonth', height: 'auto', selectable: true,
        headerToolbar: { left: 'today', center: 'prev title next', right: 'dayGridMonth,timeGridWeek,timeGridDay,listWeek' },
        buttonText: { today: 'Hoje', month: 'Mês', week: 'Semana', day: 'Dia', list: 'Lista' },
        events: [], eventClick: (info) => this.abrirEvento(info.event.id),
        eventDidMount: (info) => this.montarIndicadorConfirmacaoEvento(info),
        dateClick: (info) => this.novo(info.date),
        datesSet: (info) => { this.periodo = { inicio: info.start, fim: info.end }; this.carregarEventos() },
      },
    }
  },
  computed: { ...mapGetters(['isInRole']) },
  created() { this.iniciar() },
  methods: {
    falha(e) { this.erro = e && e.data && e.data.erro ? e.data.erro : 'Não foi possível concluir a operação.' },
    dataHora(v) { return v ? new Date(v).toLocaleString('pt-BR') : '—' },
    async iniciar() {
      try {
        this.empresas = (await http.get('/api/rh/estrutura/empresas')).data || []
        const atual = Number(this.$store.state.unidadeId)
        this.unidadeId = this.empresas.some((x) => x.id === atual) ? atual : (this.empresas[0] && this.empresas[0].id) || null
        await this.carregarEmpresa()
      } catch (e) { this.falha(e) }
    },
    async selecionarEmpresa(id) { this.unidadeId = id; await this.carregarEmpresa() },
    async carregarEmpresa() {
      this.pedidoAtual++; this.responsavelId = null; this.eventos = []; this.funcionarios = []
      this.atualizarCalendario([])
      if (!this.unidadeId) return
      const unidade = this.unidadeId
      try {
        const resposta = await http.get('/api/ead-agenda/funcionarios', { params: { unidadeId: unidade } })
        if (unidade !== this.unidadeId) return
        this.funcionarios = resposta.data || []
        await this.carregarEventos()
      } catch (e) { this.falha(e) }
    },
    recarregar() { this.carregarEventos() },
    atualizarCalendario(eventos) {
      const calendario = this.$refs.calendario
      if (!calendario) return
      const api = calendario.getApi()
      api.getEventSources().forEach((fonte) => fonte.remove())
      api.addEventSource(eventos)
    },
    montarIndicadorConfirmacaoEvento(info) {
      if (!info || !info.el || !info.event || info.el._eadIndicadorConfirmacao) return
      const confirmado = info.event.extendedProps.status === 'confirmado'
      const indicador = document.createElement('b')
      const ponto = info.el.querySelector('.fc-daygrid-event-dot, .fc-list-event-dot')
      const titulo = info.el.querySelector('.fc-event-title, .fc-list-event-title')
      indicador.className = `ead-event-confirmacao ${confirmado ? 'has-text-success' : 'has-text-danger'}`
      indicador.textContent = confirmado ? '\u221A' : '!'
      indicador.setAttribute('title', confirmado ? 'Confirmado' : 'Não confirmado')
      indicador.setAttribute('aria-label', confirmado ? 'Confirmado' : 'Não confirmado')
      if (ponto) ponto.insertAdjacentElement('afterend', indicador)
      else if (titulo) titulo.insertAdjacentElement('afterbegin', indicador)
      else return
      info.el._eadIndicadorConfirmacao = indicador
    },
    async carregarEventos() {
      if (!this.unidadeId || !this.periodo.inicio || !this.periodo.fim) return
      const pedido = ++this.pedidoAtual
      this.loading = true
      try {
        const params = { unidadeId: this.unidadeId, inicio: this.periodo.inicio.toISOString(), fim: this.periodo.fim.toISOString(), responsavelId: this.responsavelId, tipo: this.tipoFiltro }
        const resposta = await http.get('/api/ead-agenda', { params })
        if (pedido !== this.pedidoAtual) return
        this.eventos = resposta.data || []
        this.atualizarCalendario(this.eventos.map((x) => ({ id: x.chave, title: x.titulo,
          start: x.inicio, end: x.fim, color: (this.tiposFiltro.find((t) => t.valor === x.tipo) || {}).cor,
          extendedProps: { status: x.status } })))
      } catch (e) { if (pedido === this.pedidoAtual) this.falha(e) } finally { if (pedido === this.pedidoAtual) this.loading = false }
    },
    novo(data) {
      const inicio = data instanceof Date ? new Date(data) : new Date()
      if (data instanceof Date && !inicio.getHours()) inicio.setHours(9)
      const fim = new Date(inicio.getTime() + 60 * 60000)
      this.formulario = { id: null, funcionarioId: null, responsavelId: this.responsavelId, tipo: '', inicio: local(inicio), fim: local(fim), observacoes: '' }
      this.modal = true
    },
    abrirEvento(chave) { this.selecionado = this.eventos.find((x) => x.chave === chave); this.mostrarHistorico = false; this.historico = []; this.modalEvento = !!this.selecionado },
    editarSelecionado() {
      const x = this.selecionado
      this.formulario = { ...x, inicio: local(x.inicio), fim: local(x.fim) }
      this.modalEvento = false; this.modal = true
    },
    async salvar() {
      if (new Date(this.formulario.fim) <= new Date(this.formulario.inicio)) { this.erro = 'A data final deve ser posterior à inicial.'; return }
      this.salvando = true
      try {
        const x = { ...this.formulario, unidadeId: this.unidadeId, inicio: new Date(this.formulario.inicio).toISOString(), fim: new Date(this.formulario.fim).toISOString() }
        await http.post('/api/ead-agenda', x)
        this.modal = false; await this.carregarEventos()
        this.$buefy.toast.open({ message: 'Evento salvo.', type: 'is-success' })
      } catch (e) { this.falha(e) } finally { this.salvando = false }
    },
    async alterarStatus(status) {
      if (this.alterandoStatus || !this.selecionado || !this.selecionado.id) return
      this.alterandoStatus = true
      try {
        await http.put(`/api/ead-agenda/${this.selecionado.id}/status`, { unidadeId: this.unidadeId, status })
        this.modalEvento = false
        await this.carregarEventos()
        this.$buefy.toast.open({ message: 'Status atualizado.', type: 'is-success' })
      } catch (e) { this.falha(e) } finally { this.alterandoStatus = false }
    },
    confirmarEvento() {
      this.$buefy.dialog.confirm({ title: 'Confirmar evento', message: 'Confirma este evento?', confirmText: 'Confirmar', cancelText: 'Voltar', type: 'is-success', onConfirm: () => this.alterarStatus('confirmado') })
    },
    confirmarCancelamento() {
      this.$buefy.dialog.confirm({ title: 'Cancelar evento', message: 'Confirma o cancelamento?', confirmText: 'Cancelar evento', cancelText: 'Voltar', type: 'is-danger', onConfirm: () => this.alterarStatus('cancelado') })
    },
    async abrirHistorico() {
      try { this.historico = (await http.get(`/api/ead-agenda/${this.selecionado.id}/historico`, { params: { unidadeId: this.unidadeId } })).data || []; this.mostrarHistorico = true }
      catch (e) { this.falha(e) }
    },
  },
}
</script>

<style scoped>
.ead-agenda ::v-deep .rh-kicker {
  letter-spacing: 0.15em;
  font-size: 11px;
  font-weight: 800;
  color: var(--teal);
  margin: 0;
}
.fc-toolbar-chunk{ display: contents !important; }
.ead-agenda {
  --navy: #0b1a3e;
  --blue: #007bff;
  --teal: #0e8fa8;
  padding: 0 1.25rem 2rem;
}
.ead-toolbar { display: flex; align-items: flex-end; justify-content: space-between; gap: 1rem; flex-wrap: wrap; }
.ead-toolbar .field { min-width: 16rem; }
.ead-tipos { display: flex; gap: .5rem; flex-wrap: wrap; margin: .5rem 0 1.25rem; }
.ead-dot { display: inline-block; width: .7rem; height: .7rem; border-radius: 50%; margin-right: .4rem; }
.ead-agenda ::v-deep .ead-event-confirmacao { display: inline-block; flex: none; font-weight: 700; line-height: 1; margin-right: .25rem; }
.modal-card { max-width: calc(100vw - 2rem); }
@media (max-width: 600px) { .ead-agenda { padding: 0 .5rem 1rem; } .ead-toolbar .field { width: 100%; } }
</style>
